export default __webpack_public_path__ + "static/media/c002-whatsapp-01.c3de8142.png";